package com.eladfinish.bible.contest.screens.browse.usecases

import com.eladfinish.bible.contest.data.common.AssetReader
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi

class PrepareHtmlForPdfUseCase(private val assetReader: AssetReader) {

    @OptIn(ExperimentalEncodingApi::class)
    operator fun invoke(html: String): String {
        val fontBytes = assetReader.readBinaryFile(fileName = "fonts/Keter-Medium.ttf")
        if (fontBytes.isEmpty()) return html
        val base64Font = Base64.encode(source = fontBytes)
        val inlineStyle = """
            <style>
            @font-face {
                font-family: 'Keter';
                src: url('data:font/truetype;base64,$base64Font');
            }
            @page {
                margin: 20mm 15mm 26mm 15mm;
                @bottom-center {
                    content: counter(page) " / " counter(pages);
                    font-family: 'Keter', serif;
                    font-size: 10pt;
                }
            }
            body { font-family: 'Keter', serif; font-size: medium; padding-bottom: 14mm; }
            .pdf-footer-credit {
                position: fixed;
                left: 0;
                right: 0;
                bottom: 10mm;
                text-align: center;
                direction: rtl;
                font-family: 'Keter', serif;
                font-size: 9pt;
            }
            .pdf-footer-credit a { color: #1A73E8; text-decoration: underline; }
            h3 { text-align: center; display: block; width: 100%; font-size: 2em; }
            .verse-count { font-size: 1.2em; margin-top: -8px; margin-bottom: 12px; text-align: center; display: block; }
            table { width: 100% !important; border-collapse: collapse; }
            th, td { text-align: center; border: 1px solid black; }
            th { border-top: 2px double black; border-bottom: 2px double black; }
            .reysha { text-align: right !important; vertical-align: text-top; }
            .seyfa { text-align: left !important; vertical-align: text-top; }
            thead th:nth-child(3) { text-align: right; }
            thead th:nth-child(4) { text-align: left; }
            .center { text-align: center; }
            .small { font-size: small; }
            div.center { width: 100%; display: block; }
            </style>
        """.trimIndent()
        val footer =
            """<div class="pdf-footer-credit">נוצר על ידי """ +
                """<a href="https://biblecontest-f3b7c.web.app/">אפליקציית הראשון בחידון</a></div>"""

        return html
            .replace(oldValue = "</head>", newValue = "$inlineStyle\n</head>")
            .replace(oldValue = "</body>", newValue = "$footer\n</body>")
    }
}
